<!-- 学籍卡 -->
<template>
    <div class="el-TemplateInfo">
        <el-row class="page_content">
            <el-row>
                <templateEdit :key="menuInfoShow" :showInfo="showInfo" :toolShow="true" :templateName="menuInfo.templateName"></templateEdit>
            </el-row>
        </el-row>
    </div>
</template>
<script>
import templateEdit from "@/components/templateEdit";	//模板
export default {
    name: "TemplateInfo",
    components: {
        templateEdit
    },
    data() {
        return {
            htmlInfo:"",
            menuInfoShow:null,
            menuIndex:null,
            menuInfo:{}, //模板信息
            showInfo:{
                edit:true, //是否可编辑
                print:true, //是否可打印
                down:true, //是否可下载
                save:true, //是否可保存
            }
        };
    },
    created() {
        this.getTemplate();
    },
    methods: {
        getTemplate(){
            this.menuInfoShow = new Date().getTime();
            this.menuInfo = {
                templateName: this.$route.query.templateName
            }

            //let menuIndex = window.atob(this.$route.query.menuIndex);
            // this.menuInfo = window.getTemplateMenuList[menuIndex];
            // this.showInfo.print = this.menuInfo.isPrint;
            // this.showInfo.down = this.menuInfo.isExport;
        }
    },
    watch: {
        '$route': function(){ //路由变化，重新加载
            this.getTemplate();
        }
    }
};
</script>
<style  lang="less">
  @import '../../styles/base.less';
  .el-TemplateInfo{
    .page_content{
        padding: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/TemplateInfo.vue